/** Case-insensitive exact match for duplicate detection (BR-7). */
export function normalizeQuestionBankPrompt(raw: string): string {
  return raw.trim().toLowerCase()
}

export function isDuplicateQuestionBankPrompt(
  prompt: string,
  entries: readonly { prompt: string }[],
): boolean {
  const normalized = normalizeQuestionBankPrompt(prompt)
  if (!normalized) return false
  return entries.some((e) => normalizeQuestionBankPrompt(e.prompt) === normalized)
}
